import { render, staticRenderFns } from "./notification.vue?vue&type=template&id=39e565a8&scoped=true"
import script from "./notification.vue?vue&type=script&lang=js"
export * from "./notification.vue?vue&type=script&lang=js"
import style0 from "./notification.vue?vue&type=style&index=0&id=39e565a8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39e565a8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39e565a8')) {
      api.createRecord('39e565a8', component.options)
    } else {
      api.reload('39e565a8', component.options)
    }
    module.hot.accept("./notification.vue?vue&type=template&id=39e565a8&scoped=true", function () {
      api.rerender('39e565a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/insurance/insuranceManage/mainFrom/notification.vue"
export default component.exports